import { Avatar } from '@applyboard/crystal-ui'

import { getIcon } from './utils'
import { DecisionDocumentTags } from '../../../../../utils/enums'

type ApplicationDetailCardTitleIconProps = Readonly<{
  decisionDocumentTag: DecisionDocumentTags
  activeRecord?: boolean
}>

export function ApplicationDetailCardTitleIcon(props: ApplicationDetailCardTitleIconProps) {
  const { intent, icon } = getIcon(props.decisionDocumentTag, props.activeRecord)
  return <Avatar intent={intent} variant="highlighted" icon={icon} />
}
